import { initDom, dom } from './dom.js';
import {
    exitDailyChallenge,
    goToNextDailyLevel,
    initDailyChallenge,
    pauseDailyTimer,
    recordDailyAnswer,
    resumeDailyChallengeIfNeeded,
    showDailyLeaderboard,
} from './daily.js';
import {
    handleTimeActionButton,
    initTimeChallenge,
    pauseTimeTimer,
    recordTimeAnswer,
} from './time.js';
import { initLevelButtons, updateLevelButtons } from './levels.js';
import { generateExplanationModule } from './explanation.js';
import {
    startGame,
    selectLevel,
    replayLevel,
    showAnswerFeedback,
    parseSliderAnswer,
    maybeShowSummary,
} from './game.js';
import { initMeasurementInteraction, syncActionButtons } from './measurement.js';
import { enableExplanationScrollLayout } from './layout.js';
import { updateViewAndDraw } from './radar.js';
import { calculateScore } from './scoring.js';
import { state } from './state.js';
import { updateSliderDisplay } from './slider.js';

initDom();
initLevelButtons(selectLevel);
initMeasurementInteraction();
initDailyChallenge();
initTimeChallenge();

dom.submitBtn.addEventListener('click', async () => {
    if (dom.submitBtn.disabled) return;
    dom.submitBtn.disabled = true;
    dom.slider.disabled = true;
    dom.slider.classList.add('submitted');

    const rawValue = parseFloat(dom.slider.value);
    const yourError = parseSliderAnswer(rawValue);

    let score = 0;
    let timeOutcome = null;

    if (state.gameMode === 'time') {
        pauseTimeTimer();
        timeOutcome = recordTimeAnswer({
            level: state.currentProblem,
            rawValue,
            yourError,
        });
    } else {
        if (state.gameMode === 'daily') {
            pauseDailyTimer();
        }
        score = calculateScore(yourError, state.currentProblem);
        updateLevelButtons({ animateCurrentFill: true });
    }

    enableExplanationScrollLayout();

    dom.explanationContainer.innerHTML = generateExplanationModule(
        state.aircraft1,
        state.aircraft2,
        state.intersectionPoint,
        state.solution,
    );
    dom.explanationContainer.classList.remove('hidden');
    showAnswerFeedback(rawValue);

    if (state.gameMode === 'time') {
        if (timeOutcome?.outcome !== 'failed') {
            updateLevelButtons({ animateCurrentFill: true });
        }
    } else if (state.gameMode === 'daily') {
        const completed = recordDailyAnswer({
            level: state.currentProblem,
            rawValue,
            score,
        });
        if (completed) {
            await showDailyLeaderboard();
        }
    } else {
        maybeShowSummary();
    }

    syncActionButtons();
});

dom.replayLevelBtn.addEventListener('click', () => {
    if (state.gameMode === 'time') {
        handleTimeActionButton();
        return;
    }
    if (state.gameMode === 'daily') {
        goToNextDailyLevel();
        return;
    }
    replayLevel();
});
dom.resetGameBtn.addEventListener('click', startGame);
dom.exitDailyBtn.addEventListener('click', exitDailyChallenge);
dom.slider.addEventListener('input', (e) => updateSliderDisplay(e.target.value));
window.addEventListener('resize', updateViewAndDraw);

if (!resumeDailyChallengeIfNeeded()) {
    startGame();
}
